import { createTypedValidator } from '@takeshape/json-schema';
import * as agentMessagePayload from "./agent-message-payload.js";
export const shapeName = 'TSSendAgentFeedback';
export const schema = {
    type: 'object',
    properties: {
        messageId: {
            type: 'string',
            description: 'Message ID for the message.'
        },
        ...agentMessagePayload.schema.properties.feedback.properties
    },
    required: ['messageId', ...agentMessagePayload.schema.properties.feedback.required],
    additionalProperties: false
};
export const validate = createTypedValidator(schema);
